<template>
  <div class="container" >

    <div class="form">
      <el-form ref="formRef" :inline="true" label-width="90px" :model="form">
        <el-row>
          <el-col :span="5">
            <el-form-item label="食材名称" prop="ingredientName">
              <el-input v-model="form.ingredientName" clearable placeholder="请输入食材名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="类型" prop="category">
              <el-select v-model="form.category" clearable placeholder="请选择类型">
                <el-option v-for="item in dietStandardCategoryList"
                           :key="item.dictKey"
                           :label="item.dictValue" :value="item.dictKey"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <div class="buttons" >
              <el-button type="primary" @click="query_handler" >查询</el-button>
              <el-button @click="reset_handler" >重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="list">
      <div class="add" >
        <el-button @click="add_handler" class="add-button-class" type="primary" size="small" >录入食材</el-button>
      </div>
      <el-table
          :data="table"
          style="width: 100%">
        <el-table-column
            prop="serialNumber"
            align="center"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="ingredientName"
            align="center"
            label="食材名称">
        </el-table-column>
        <el-table-column
            prop="category"
            align="center"
            label="类型">
          <template #default="{ row }" >
            <span>{{ categoryName(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column
            prop="energy"
            align="center"
            label="能量（kcal）">
        </el-table-column>
        <el-table-column
            prop="protein"
            align="center"
            label="蛋白质（g）">
        </el-table-column>
        <el-table-column
            prop="fat"
            align="center"
            label="脂肪（g）">
        </el-table-column>
        <el-table-column
            prop="carbohydrate"
            align="center"
            label="碳水化合物（g）">
        </el-table-column>
        <el-table-column
            fixed="right"
            align="center"
            label="操作">
          <template #default="{ row }" >
            <div class="links" >
              <el-link type="primary" @click="edit_handler(row)" >编辑</el-link>
              <el-popconfirm
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  icon="el-icon-info"
                  title="确定要删除该食材吗？"
                  @confirm="confirmEvent(row)"
                  @cancel="cancelEvent">
                <template #reference>
                  <span class="reference-class">
                    <el-link type="danger" >删除</el-link>
                  </span>
                </template>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="form.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
    <AddDialog v-model="add_data.show" v-bind="add_data" @updateList="getList" />
  </div>
</template>

<script>
import AddDialog from "./components/AddDialog";
export default {
  name: "IngredientList",
  components: {
    AddDialog
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 10,
        ingredientName: "",
        category: "",
      },
      table: [],
      total: 0,
      dietStandardCategoryList: [],
      add_data: {
        show: false,
        id: "",
        ingredientName: "",
        category: "",
        energy: "",
        protein: "",
        fat: "",
        carbohydrate: "",
      }
    }
  },
  computed: {
    categoryName() {
      return function (row) {
        const category = (this.dietStandardCategoryList || []).find(item => item.dictKey === row.category);
        if (!category) return "";
        return category.dictValue;
      }
    }
  },
  created() {
    this.getDietStandardCategoryList();
    this.getList();
  },
  mounted() {

  },
  methods: {
    query_handler() {
      this.form.pageNum= 1;
      this.getList();
    },
    reset_handler() {
      this.$refs.formRef.resetFields();
      this.getList();
    },
    async getDietStandardCategoryList() {
      try{
        const res = await this.$get(`dictionary/type/${"diet_standard_category"}`);
        if (!res) return false;
        this.dietStandardCategoryList= res.data;
      }catch (e) {
        console.error(`获取食材类型接口失败`, e);
      }
    },
    async getList() {
      try {
        const res = await this.$get("ingredient/list", this.form);
        if (!res) return false;
        const { data } = res;
        this.total = data.total;
        this.table = data.list;
      }catch (e) {
        console.error(`获取食材列表接口失败`, e);
      }
    },
    // 添加
    add_handler() {
      this.add_data.id= "";
      this.add_data.show= true;
    },
    // 编辑
    edit_handler(row) {
      this.add_data.id = row.id;
      this.add_data.ingredientName = row.ingredientName;
      this.add_data.category = row.category;
      this.add_data.energy = row.energy;
      this.add_data.protein = row.protein;
      this.add_data.fat = row.fat;
      this.add_data.carbohydrate = row.carbohydrate;
      this.add_data.show= true;
    },
    // 确定删除
    async confirmEvent(row) {
      try {
        const res = await this.$del(`ingredient/delete/${row.id}`);
        if (!res) return false;
        await this.getList();
      }catch (e) {
        console.error(`删除食材接口失败`, e);
      }
    },
    // 取消删除
    cancelEvent() {

    },
    handleSizeChange(e) {
      this.form.pageSize= e;
      this.getList();
    },
    handleCurrentChange(e) {
      this.form.pageNum= e;
      this.getList();
    },
  }
}
</script>

<style scoped lang="scss">
.container{
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  .list{
    flex: 1;
    .add-button-class{
      width: 100px;
    }
  }
}
.buttons{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>
